module.exports = __webpack_public_path__ + "img/advisory_core_select03.aab9d853.png";